// Module
var code = `<div> <svg xmlns="http://www.w3.org/2000/svg" viewBox="-50 -50 100 100" preserveAspectRatio="xMidYMid" class="animation {{::\$ctrl.classes}}"> <circle cx="0" cy="0" r="43" stroke-dasharray="223.83847656827277 74.61282552275759" fill="none"></circle> </svg> </div> <div ng-if="::\$ctrl.label" class="label" ng-bind="::\$ctrl.label"></div> `;
// Exports
export default code;